<template>
    <textarea
        :value="modelValue"
        @input="$emit('update:modelValue', $event.target.value)"
        class="px-4 py-3 w-full text-sm border-2 border-black font-bold focus:outline-indigo"
    />
</template>

<script>
export default {
    props: {
        modelValue: null,
    },
    emits: ['update:modelValue']
}
</script>
